.card {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-3);
  border: 1px solid var(--tuna-color-border);
  border-radius: var(--tuna-radius-sm);
  background: var(--tuna-color-surface);
}

.cardActive {
  outline: 2px solid var(--tuna-color-accent);
  outline-offset: -2px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--tuna-spacing-2);
}

.title {
  font-size: var(--tuna-fontsize-md);
  font-weight: 600;
  margin: 0;
}

.applyButton {
  padding: var(--tuna-spacing-1) var(--tuna-spacing-3);
  border: 1px solid var(--tuna-color-border);
  border-radius: var(--tuna-radius-sm);
  background: var(--tuna-color-surface);
  cursor: pointer;
}

.applyButton:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.applyButton[aria-pressed='true'] {
  background: var(--tuna-color-accent);
  color: var(--tuna-color-on-accent);
}

.copy {
  font-size: var(--tuna-fontsize-sm);
  color: var(--tuna-color-text-secondary);
  margin: 0;
}

.caption {
  font-size: var(--tuna-fontsize-xs);
  color: var(--tuna-color-text-tertiary);
  margin: 0;
}
